import { Link } from 'react-router-dom'
import LandingNav from './LandingNav'
import LandingFooter from './LandingFooter'

export default function ComingSoonPage({ title }: { title: string }) {
  return (
    <div className="min-h-screen bg-[#030712] flex flex-col">
      <LandingNav />

      <div className="flex-1 flex flex-col items-center justify-center px-4">
        <h1
          className="text-3xl md:text-5xl font-extrabold tracking-tight mb-4"
          style={{
            fontFamily: 'Barlow, sans-serif',
            fontWeight: 900,
            background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            filter: 'drop-shadow(0 0 16px rgba(6, 182, 212, 0.3))',
          }}
        >
          {title}
        </h1>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-500/5 border border-amber-500/30 mb-6">
          <span className="font-mono text-xs text-amber-400">Coming Soon</span>
        </div>
        <p className="font-mono text-sm text-slate-500 mb-8 text-center max-w-sm">
          We're working on this. Check back soon.
        </p>
        <Link
          to="/"
          className="font-mono text-xs text-cyan-400 hover:text-cyan-300 transition-colors"
        >
          Back to Home
        </Link>
      </div>

      <LandingFooter />
    </div>
  )
}
